import { Sections } from '../types/Sections';

export const MAIN_SECTIONS_LIST = [
  Sections.EASYBUY,
  Sections.ADVANTAGES,
  Sections.SIXINTIX,
];
